
const Footer = () => {
  return (
    <footer className="bg-[#1B3A52] text-white relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.4'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }}></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-6 py-14">
        {/* Upper Footer */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10 mb-10">
          {/* Brand Section */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <img 
                src="https://public.readdy.ai/ai/img_res/52abf2f2-316b-4670-aeb3-1738417e7b43.png" 
                alt="Pastor Don R. Vining" 
                className="h-11 w-11 object-contain"
              />
              <span className="text-lg font-serif font-semibold">Pastor Don R. Vining</span>
            </div>
            <p className="text-white/80 text-sm mb-5 leading-relaxed">
              Sharing God's Word through written ministry, inspiring faith, hope, and spiritual growth.
            </p>
          </div>

          {/* Ministry Links */}
          <div>
            <h4 className="text-white font-semibold text-sm mb-4">Ministry</h4>
            <ul className="space-y-2">
              <li><a href="/" className="text-white/70 hover:text-[#D4AF37] transition-colors text-xs cursor-pointer">Home</a></li>
              <li><a href="/about" className="text-white/70 hover:text-[#D4AF37] transition-colors text-xs cursor-pointer">About Pastor Don</a></li>
              <li><a href="/books" className="text-white/70 hover:text-[#D4AF37] transition-colors text-xs cursor-pointer">Books</a></li>
            </ul>
          </div>

          {/* Resources Links */}
          <div>
            <h4 className="text-white font-semibold text-sm mb-4">Resources</h4>
            <ul className="space-y-2">
              <li><a href="#devotions" className="text-white/70 hover:text-[#D4AF37] transition-colors text-xs cursor-pointer">Devotions</a></li>
              <li><a href="/contact" className="text-white/70 hover:text-[#D4AF37] transition-colors text-xs cursor-pointer">Prayer Requests</a></li>
            </ul>
          </div>

          {/* Connect Links */}
          <div>
            <h4 className="text-white font-semibold text-sm mb-4">Connect</h4>
            <ul className="space-y-2">
              <li><a href="/contact" className="text-white/70 hover:text-[#D4AF37] transition-colors text-xs cursor-pointer">Contact Us</a></li>
              <li><a href="https://www.facebook.com/leavittpeakpress" target="_blank" rel="noopener noreferrer" className="text-white/70 hover:text-[#D4AF37] transition-colors text-xs cursor-pointer">Facebook</a></li>
            </ul>
          </div>
        </div>

        {/* Closing Scripture */}
        <div className="text-center mb-6">
          <p className="text-white/70 italic text-sm">
            "Let your light shine before others" — Matthew 5:16
          </p>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/20 pt-6 flex flex-col md:flex-row items-center justify-between gap-5">
          <p className="text-white/60 text-xs">
            © 2025 Pastor Don R. Vining Ministry. All rights reserved.
          </p>

          {/* Social Icons */}
          <div className="flex items-center gap-4">
            <a href="https://www.facebook.com/leavittpeakpress" target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-lg border-2 border-white/30 flex items-center justify-center hover:border-[#D4AF37] hover:bg-[#D4AF37]/10 transition-all cursor-pointer">
              <i className="ri-facebook-fill text-white text-base"></i>
            </a>
            <a href="/contact" className="w-9 h-9 rounded-lg border-2 border-white/30 flex items-center justify-center hover:border-[#D4AF37] hover:bg-[#D4AF37]/10 transition-all cursor-pointer">
              <i className="ri-mail-line text-white text-base"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
